//分包公司表格导出参数
export const companyFile = {
    name: "单位名称",
    code: "统一社会信用代码",
    legal_person: "法人",
    registered_capital: "注册资本(万元)",
    establish: "成立日期",
    business_term: "营业期限(年)",
    contacts: "联系人姓名",
    telephone: "联系电话",
    address: "单位地址",
}

//分包公司表格导出参数
export const companyFileBatch = [
    {
        key: 'name',
        value: '单位名称(必填)',
        must: true
    },
    {
        key: 'code',
        value: '统一社会信用代码',
        must: false
    },
    {
        key: 'legal_person',
        value: '法人',
        must: false
    },
    {
        key: 'registered_capital',
        value: '注册资本(万元)',
        must: false
    },
    {
        key: 'establish',
        value: '成立日期(格式为2000/10/01或2000-10-10)',
        must: false,
        cellDates: true
    },
    {
        key: 'business_term',
        value: '营业期限(年)',
        must: false
    },
    {
        key: 'contacts',
        value: '联系人姓名',
        must: false
    },
    {
        key: 'telephone',
        value: '联系电话',
        must: false
    },
    {
        key: 'address',
        value: '单位地址',
        must: false
    }
]


//人员表格导出参数
export const personFile = {
    name: "姓名",
    phone: "联系电话",
    gender: "性别",
    // age: "年龄",
    work_name: "工种",
    duties: "职务",
    job_no: "工号",
    address: "住址",
    create_time: "入场时间",
}

//培训表格导出参数
export const trainFile = {
    person_name: '姓名',
    company_name: '分包单位',
    study_duration_convert: '总培训时长',
    pass_type_transformed: '是否合格',
    score: '分数'
}



//人员表格导出参数
export const personFileBatch = [
    {
        key: 'name',
        value: '姓名(必填)',
        must: true
    },
    {
        key: 'id_no',
        value: '身份证号(必填)',
        must: true
    },
    {
        key: 'phone',
        value: '手机号',
        must: false
    },
    // {
    //     key: 'age',
    //     value: '年龄',
    //     must: false
    // },
    {
        key: 'duties',
        value: '职务',
        must: false,
    },
    {
        key: 'job_no',
        value: '工号',
        must: false
    },
    {
        key: 'address',
        value: '住址',
        must: false
    }
]